import { CONFIG_UPDATE, ConfigState } from 'src/reducers/config/types';

import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import { setUrls, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { observeStore, store } from 'Utilities/store';

const _getConfigWithCountry = (country: string) => {
  return new Promise<ConfigState>((resolve, reject) => {
    mediator
      .request<ConfigState>('api:invoke', {
        method: 'POST',
        url: urls.lslApi + 'sharing/config',
        data: {
          country,
        },
      })
      .then((result) => {
        if (result.status === 0) {
          resolve(result.data);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleUpdateConfig = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    _getConfigWithCountry(request.country)
      .then((res) => {
        if (store) {
          store.dispatch({ type: CONFIG_UPDATE, config: res, country: request.country });
        }

        analyticsManager.initialize(res.analytics);

        // this allows a service to wait until an update is done
        mediator.publish('config:UpdatedConfigForCountry', { country: request.country });
        resolve(res);
      })
      .catch((err) => {
        // what do we do here?
        log.error(err);
        // mediator.publish('config:UpdatedConfigForCountry', {
        //   error: {
        //     status: err.status,
        //   },
        // });
        reject(err);
      });
  });
};

mediator.once('store:created', () => {
  // Update the service urls when config changes
  observeStore((state) => state.config, setUrls);
  // Update when user country changes
  // observeStore(
  //   store,
  //   (state) => state.user.country,
  //   (country: string) => handleUpdateConfig({ country })
  // );
});

mediator.subscribe('config:updateConfig', handleUpdateConfig);
